/**
 * Los tres bloques de una cotización sirven para dos cosas distintas, y el sistema
 * original de SkyPel las confundía en una sola. Ésta es la desambiguación:
 *
 *  · modo ETAPAS   — el cliente compra las tres en secuencia. El total SUMA.
 *  · modo OPCIONES — el cliente elige UNA. El total NO suma; son alternativas.
 *
 * Por eso un producto puede estar marcado en más de un bloque, y significa cosas
 * distintas según el modo: en opciones, que va incluido en varias alternativas; en
 * etapas, que se ejecuta en varias fases y suma en cada una.
 *
 * Los rótulos son editables por cotización: no todos los proyectos se llaman igual.
 */

export const ROTULOS = {
  etapas:   ['', 'Etapa 1 — lo esencial', 'Etapa 2 — ampliación', 'Etapa 3 — completo'],
  opciones: ['', 'Opción económica', 'Opción intermedia', 'Opción completa']
}

export const esOpciones = cot => cot?.modo === 'opciones'

export const rotulo = (cot, e) =>
  cot?.etiquetas?.[e]?.trim() || ROTULOS[esOpciones(cot) ? 'opciones' : 'etapas'][e]

export const rotuloCorto = (cot, e) => (esOpciones(cot) ? `Opción ${e}` : `Etapa ${e}`)

export const abrev = (cot, e) => (esOpciones(cot) ? `O${e}` : `E${e}`)
